// @ts-nocheck
import id from "@/translations/id";
import Vue from "vue";
Vue.directive("uppercase", {
  bind (el, _, vnode) {
    el.addEventListener("input", (e) => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit("input", e.target.value.toUpperCase());
    });
  }
});


Vue.directive("modal-content", {
  bind (el, _, vnode) {
   const store = vnode.context.$store; 
   el.style.height=(store.state.app.window.height-383)+"px";
   el.style.overflow="auto";
   store.watch(()=> store.state.app.window.height, (h)=> {
     el.style.height=(h-383)+"px";
     el.style.overflow="auto";
   });
  }
});

Vue.directive("show-full-text", {
  bind (el, _, vnode) {
    let timer;
    let istrue = false;
    const delay = 500;
    const tooltip = document.createElement("div");
    tooltip.innerText = el.innerText;
    tooltip.style.position = "absolute";
    tooltip.style.background= "#fff";
    tooltip.style.border= "1px solid #efefef";
    tooltip.style.marginTop= "-32px";
    tooltip.style.marginLeft= "8px";
    tooltip.style.padding= "0 4px";
    function makeChange() {
      if(timer)
      clearTimeout(timer);

      if(istrue) {
        el?.appendChild(tooltip);
      }
    }
    el.addEventListener("touchstart", (e) => {
      istrue = true;
      timer = setTimeout(function(){ makeChange();},delay);
      if (e.preventDefault) { 
          e.preventDefault();
      } else {
          e.returnValue = false; 
      }
    });
    el.addEventListener("touchend", (e) => {
      istrue = false;
      el.removeChild(tooltip);
    });
  }
});